import * as S from './CheckMarkStyles';

const CheckMark = () => <S.CheckMark />;

export default CheckMark;
